export default __webpack_public_path__ + "static/media/icon-stats.4c1a1ed9.svg";